// W kontekście umów z deweloperem (inwestycje kompasowe)
export enum OfferStatusStatus {
    STATUS_STATUS_IN_PREPARATION = 0, // W przygotowaniu
    STATUS_STATUS_TO_ACQUIRE = 1, // Do pozyskania - brak podpisanej umowy (inwestycja kompasowa)
    STATUS_STATUS_CONTRACT_SIGNED = 2, // Umowa podpisana
    STATUS_STATUS_SOLD = 3 // Sprzedana
}
// W kontekście umów z deweloperem (inwestycje kompasowe)
export enum OfferStatusStatus {
    STATUS_STATUS_IN_PREPARATION = 0, // W przygotowaniu
    STATUS_STATUS_TO_ACQUIRE = 1, // Do pozyskania - brak podpisanej umowy (inwestycja kompasowa)
    STATUS_STATUS_CONTRACT_SIGNED = 2, // Umowa podpisana
    STATUS_STATUS_SOLD = 3 // Sprzedana
}
